/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";
import DeviceInfoModal from "./device-info-modal";
import { useEffect, useState } from "react";
import { TDevice, getDeviceList } from "apis/visitors/device";
import { Alert, Snackbar } from "@mui/material";
import { ColorTag } from "./components/color-tag";
import { OnOffTag } from "./components/on-off-tag";
import usePermissionPolicy from "hook/usePermissionPolicy";
import { Container, Heading } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import DeviceAccountManagement from "pages/meeting/MeetingRoomManage/MeetingRoomDeviceManagement/DeviceAccountManagement/DeviceAccountManagement";

const Annotation = styled.p`
  color: ${theme.neutral500};
  font-size: 12px;
  font-weight: 500;
`;

const HeaderContainer = styled.div`
  background-color: ${theme.neutral50};
  padding: 16px 24px;
  border-radius: 5px;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  display: grid;
  grid-template-columns: 0.5fr 1.6fr 1fr 1fr 1fr;
`;

const RowContainer = styled.div`
  padding: 16px 24px;
  gap: 10px;
  display: flex;
  display: grid;
  grid-template-columns: 0.5fr 1.6fr 1fr 1fr 1fr;
  border-bottom: 1px solid ${theme.neutral100};
  align-items: center;

  color: ${theme.neutral600};
  font-size: 16px;
  font-weight: 500;

  cursor: pointer;
  &:hover {
    background-color: ${theme.neutral50};
  }
`;

const Device = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [devices, setDevices] = useState<TDevice[]>([]);
  const [selectId, setSelectId] = useState<number>();
  const [openToast, setOpenToast] = useState<boolean>(false);
  const { canAccessVisitors기기관리 } = usePermissionPolicy();

  useEffect(() => {
    if (!canAccessVisitors기기관리) {
      alert("권한이 없는 접근입니다.");
      window.location.href = "/";
    }
    getDeviceList().then((res) => setDevices(res));
  }, []);

  return (
    <Container>
      <Heading>
        <UI.Typography
          type="title03"
          fontStyle="bold"
          color="var(--alias-color-label-neutral)"
          style={{
            padding: "24px 0 24px 20px",
          }}
        >
          기기 관리
        </UI.Typography>
      </Heading>

      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={() => setOpenToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="success">기기 정보가 성공적으로 변경되었습니다.</Alert>
      </Snackbar>
      <Annotation
        style={{
          padding: "0 20px",
        }}
      >
        * 태블릿 로그인 시, 설정할 기기 조회 목록입니다.
      </Annotation>

      <div style={{ margin: "0 20px" }}>
        <TableHeader />
        {devices.map((item, index) => (
          <TableRow
            device={item}
            index={index + 1}
            onClick={() => {
              setSelectId(index);
              setOpenModal(true);
            }}
          />
        ))}
      </div>
      {selectId !== undefined && (
        <DeviceInfoModal
          modalIsOpen={openModal}
          closeModal={() => setOpenModal(false)}
          device={devices[selectId]}
          onChangeDevice={async () => {
            const res = await getDeviceList();
            if (res) {
              setDevices(res);
              setOpenToast(true);
            }
          }}
        />
      )}
      <UI.Typography
        type="title03"
        fontStyle="bold"
        color="var(--alias-color-label-neutral)"
        style={{
          padding: "48px 20px 0 20px",
        }}
      >
        기기 계정 관리
      </UI.Typography>
      <DeviceAccountManagement isShow />
    </Container>
  );
};

export default Device;

const TableHeader = () => {
  return (
    <HeaderContainer>
      <p>No.</p>
      <p>기기명</p>
      <p>테마</p>
      <p>초인종 활성화</p>
      <p>당일 방문 활성화</p>
    </HeaderContainer>
  );
};

const TableRow = ({ device, index, onClick }: { device: TDevice; index: number; onClick?: () => void }) => {
  return (
    <RowContainer onClick={onClick}>
      <p>{index}</p>
      <p>{device.deviceName}</p>
      <ColorTag color={device.visitorsSettingTheme.primary} />
      <OnOffTag state={device.isDoorBellEnabled} />
      <OnOffTag state={device.isWalkInVisitEnabled} />
    </RowContainer>
  );
};
